import { Redirect } from 'react-router-dom';
import { zIndex } from '@cbhq/cds-common/tokens/zIndex';
import { VStack } from '@cbhq/cds-web/layout';

import { useAppState } from ':cloud/contexts/AppStateContext';
import { DashboardProvider } from ':cloud/contexts/DashboardProvider';
import useProjectNavigation from ':cloud/hooks/useProjectNavigation';
import { EventName, useLogViewOnMount } from ':cloud/init/clientAnalytics/logging';
import { useGetProjects } from ':cloud/queries/Projects/useGetProjects';
import { useGetUser } from ':cloud/queries/UserQueries/useGetUser';
import { AppRoute } from ':cloud/utils/routes';
import { ProjectDashboardGettingStarted } from ':cloud/widgets/dashboard/ProjectDashboardGettingStarted';
import { ProjectDashboardMonitoring } from ':cloud/widgets/dashboard/ProjectDashboardMonitoring';
import { Layout } from ':cloud/widgets/layout';
import { ProjectDashboardHeader } from ':cloud/widgets/projects/ProjectDashboardHeader';
import { LoadingSpinner } from ':cloud/widgets/sharedcomponents';

function ProjectDashboardContent() {
  return (
    // Create stacking context that keeps CDS TabbedChips underneath the mobile menu
    <VStack testID="dashboard-content" spacingBottom={3} zIndex={zIndex.interactable}>
      <VStack spacing={7} spacingTop={2}>
        <ProjectDashboardHeader />
      </VStack>
      <ProjectDashboardGettingStarted />
      <ProjectDashboardMonitoring />
    </VStack>
  );
}

export function ProjectDashboard() {
  const { activeOrg } = useGetUser();
  const { selectedProject } = useAppState();
  const { projects } = useGetProjects(activeOrg?.organizationId);

  useLogViewOnMount(EventName.dashboard_page_view);
  useProjectNavigation();

  /** if no projects exist has to be checked first, order matters */
  if (projects.length === 0) {
    return <Redirect to={AppRoute.Projects.Home} />;
  }

  if (!selectedProject) {
    return <LoadingSpinner />;
  }

  return (
    <Layout>
      <Layout.MainContainer spacingHorizontal={0} fullWidth>
        <DashboardProvider>
          <ProjectDashboardContent />
        </DashboardProvider>
      </Layout.MainContainer>
    </Layout>
  );
}
